module.exports = __webpack_public_path__ + "img/14.023292d3.jpg";